export function isUUID (input: string): boolean {
    const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

    return uuidPattern.test(input)
}

export function currencyCodeToSymbol (code: string) {
    const mapped: Record<string, string> = {
        USD: '$',
        EUR: '€',
        SEK: 'kr',
        NOK: 'kr'
    }
    return mapped[code] ?? ''
}
